import axios from 'axios';

export const createUser = async (params) => {
  const { data } = await axios.post('/users/create', params);

  return data;
};
